import React, {useContext, useEffect} from 'react';
import FormBloc from "../../../../../../../../components/form/FormBloc";
import Grid from "@mui/material/Grid";
import {ProductShowContext} from "../../../../context/ProductShowContext";
import AttributeField from "./components/AttributeField";
import {Accordion, AccordionDetails, AccordionSummary, IconButton, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormTitle from "../../../../../../../../components/form/FormTitle";
import {primaryColor} from "../../../../../../../../assets/jss/main";
import {FormattedMessage} from "react-intl";
import {useFormikContext} from "formik";

function Attributes({isRequired, ...props}) {
    const {attributeList} = useContext(ProductShowContext);
    const {attributeLoading} = useContext(ProductShowContext);
    const {validateForm} = useFormikContext();

    useEffect(() => {
        if (!attributeLoading) {
            validateForm();
        }
    }, [attributeLoading, validateForm]);

    if (attributeLoading) {
        return (
            <Grid container justifyContent="center" alignItems="center" rowSpacing={3}>
                <Grid item xs={12} textAlign="center">
                    <FormattedMessage color={primaryColor} id={'product.show.product.form.attributes.loading'} />
                </Grid>
            </Grid>
        );
    }

    if (!attributeList.length) {
        return null;
    }

    const grid = (
        <Grid container rowSpacing={3}>
            <Grid item xs={12}>
                <Grid container direction="column" rowSpacing={3}>
                    <Grid item container columnSpacing={2} rowSpacing={3}>
                        {/* first display type bool */}
                        {Object.entries(attributeList)
                            .filter(([_, values]) => values.type === 'bool' && ((isRequired && values.isRequiredForProduct) || (!isRequired && !values.isRequiredForProduct)))
                            .map(([key, values], index, arr) => (
                                <Grid
                                    item
                                    md={index % 2 !== 0 ? 6 : (index === arr.length - 1 ? 12 : 6)}
                                    xs={12}
                                    key={key}
                                >
                                    <AttributeField attribute={values} />
                                </Grid>
                            ))}
                        {/* Then display type not bool */}
                        {Object.entries(attributeList)
                            .filter(([_, values]) => values.type !== 'bool' && ((isRequired && values.isRequiredForProduct) || (!isRequired && !values.isRequiredForProduct)))
                            .map(([key, values]) => (
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                    key={key}
                                >
                                    <AttributeField attribute={values} />
                                </Grid>
                            ))}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );

    if (isRequired) {
        return (
            <FormBloc titleId='product.show.product.form.attributes.title.required'>
                {grid}
            </FormBloc>
        );
    } else {
        return (
            <Accordion
            sx={{
                width: '100%',
                border: 'none',
                boxShadow: 'none',
                '.MuiAccordion-root, .MuiAccordionSummary-root, .MuiAccordionDetails-root': {
                    paddingLeft: '0',
                    paddingRight: '0'
                },
            }}
            >
                <AccordionSummary
                    expandIcon={
                        <IconButton aria-label="settings">
                            <ExpandMoreIcon fontSize={"medium"}/>
                        </IconButton>
                    }
                    aria-controls="attributes-panel"
                    id="attributes-panel"
                >
                    <FormTitle titleId={'product.show.product.form.attributes.title'} />
                </AccordionSummary>
                <AccordionDetails>
                    {grid}
                </AccordionDetails>
            </Accordion>
        );
    }
}

export default Attributes;
